export enum FieldTypes {
    Input = "Text",
    TextArea = "TextArea",
    FileAttach = "FileUpload",
    Header = "Heading",
    Paragraph = "Paragraph",
    Separator = "Separator",
    Dropdown = "Dropdown",
    RadioButtonList = "RadioList",
    CheckboxList = "CheckList",
    Date = "Date",
}
